/* import __COLOCATED_TEMPLATE__ from './calendar-card.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import moment from 'moment-timezone';

export interface CalendarCardBlock {
  type: 'calendarCard';
  available_slots?: string[];
}

interface DateGroup {
  date: Date;
  dateKey: string;
  slots: string[];
}

interface Signature {
  Args: {
    dataBlock: CalendarCardBlock;
  };
}

export default class CalendarCard extends Component<Signature> {
  @tracked expandedDateKey: string | null = null;

  get slotsByDate(): DateGroup[] {
    let slots = this.args.dataBlock.available_slots;
    if (!slots?.length) {
      return [];
    }

    let grouped = new Map<string, string[]>();

    for (let slot of slots) {
      let dateKey = moment(slot).format('YYYY-MM-DD');
      let existing = grouped.get(dateKey);
      if (existing) {
        existing.push(slot);
      } else {
        grouped.set(dateKey, [slot]);
      }
    }

    let result: DateGroup[] = [];
    for (let [dateKey, dateSlots] of grouped) {
      result.push({
        date: moment(dateKey).toDate(),
        dateKey,
        slots: dateSlots,
      });
    }

    return result;
  }

  @action
  toggleDate(dateKey: string): void {
    if (this.expandedDateKey === dateKey) {
      this.expandedDateKey = null;
    } else {
      this.expandedDateKey = dateKey;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::CalendarCard': typeof CalendarCard;
    'inbox2/conversation-stream/part-groups/calendar-card': typeof CalendarCard;
  }
}
